import React, { useState } from 'react';
import Dashboard from './dashboard';

const StudioOS = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  const handleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      const response = await fetch('https://os.studio-soma.de/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();
      if (!response.ok) { setError(data.error); setLoading(false); return; }
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
    } catch (err) {
      setError('Server nicht erreichbar');
      setLoading(false);
    }
  };

  if (user) return <Dashboard user={user} onLogout={() => { localStorage.removeItem('token'); localStorage.removeItem('user'); setUser(null); }} />;

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: '#f7f7f5',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    }}>
      <div style={{
        width: '100%', maxWidth: '400px', padding: '48px',
        backgroundColor: '#ffffff', borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.06)'
      }}>
        <div style={{ marginBottom: '28px' }}>
          <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>
            Studio OS
          </h1>
          <p style={{ fontSize: '13px', color: '#9b9b9b', margin: 0 }}>v1.0.0</p>
        </div>

        {error && (
          <div style={{
            padding: '10px 14px', backgroundColor: '#fff0f0', border: '1px solid #ffdddd',
            borderRadius: '8px', color: '#cc0000', fontSize: '13px', marginBottom: '16px'
          }}>{error}</div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#6b6b6b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>E-Mail</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="name@studio.de"
            style={{ width: '100%', padding: '10px 14px', fontSize: '14px', border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none', backgroundColor: '#fafafa', color: '#1a1a1a', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: '40px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#6b6b6b', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Passwort</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••" onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
            style={{ width: '100%', padding: '10px 14px', fontSize: '14px', border: '1px solid #e8e8e8', borderRadius: '8px', outline: 'none', backgroundColor: '#fafafa', color: '#1a1a1a', boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button onClick={handleLogin} disabled={loading} style={{
            padding: '12px 48px', backgroundColor: loading ? '#9b9b9b' : '#1a1a1a',
            color: '#ffffff', border: 'none', borderRadius: '8px', fontSize: '14px',
            fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', letterSpacing: '0.2px'
          }}>
            {loading ? 'Einen Moment...' : 'Einloggen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudioOS;